import './style.styl';

angular
  .module(__filename, [
    'ui.router',
    'smart-table',

    require('local_modules/filters/display_order_unit').default.name,
    require('local_modules/services/supplier').default,

    require('./components/drop_off_day').default,
    require('./components/day_overrides').default,
  ])

  .config(
    ngInject(($stateProvider) =>
      $stateProvider.state('procurement_schedules.show', {
        url: '/:supplierSlug',
        template: require('./template'),
        controller: require('./controller').default,
        controllerAs: 'ctrl',
      }),
    ),
  );

export default __filename;
